<template>
  <div v-if="hasOptions" v-show="shoudDisplay" id="product-variants">
    <ul class="option-list">
      <li
        v-for="variant in options"
        :key="variant.id"
        class="option-list__item-wrapper"
      >
        <input
          :id="`variant_id_${variant.id}`"
          v-model="inputValue"
          :value="getOptionValue(variant)"
          type="radio"
          name="variant_id"
          @click="setValue(variant)"
        />
        <label class="option-list__item" :for="`variant_id_${variant.id}`">
          <span
            v-if="!variant.sku.includes('gift-card')"
            class="variant-description option-list__item-name"
          >
            {{ variant.name }}
          </span>
          <span v-if="variant.old_price" class="product-price__previous">
            {{ formatPrice(variant.old_price) }}
          </span>
          <span
            :class="[
              'price',
              'diff',
              {
                'product-price__current--colored': variant.old_price,
              },
            ]"
          >
            {{ formatPrice(variant.price) }}
          </span>
          <span
            v-if="!variant.in_stock"
            class="out-of-stock out-of-stock--singlepage"
          >
            {{ $t('product_form.sold_out') }}
          </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import BaseSelect from '~/components/product/form/BaseSelect'
import priceable from '~/mixins/priceable'

export default {
  name: 'VariantSelector',
  extends: BaseSelect,
  mixins: [priceable],
  props: {
    /** Option object key to retrive option value */
    optionValueKey: {
      type: String,
      default: 'id',
    },
    /** If true, select first option automatically */
    autoSelect: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    shoudDisplay() {
      return this.options?.length > 1
    },
    hasOptions() {
      return this.options?.length > 0
    },
  },
  methods: {
    setValue(variant) {
      // eslint-disable-next-line camelcase
      if (variant?.price || variant?.old_price) {
        this.$store.dispatch('product/setCurrentPrice', variant?.price)
        // eslint-disable-next-line camelcase
        this.$store.dispatch('product/setOldPrice', variant?.old_price)
      }
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/css/option-list.scss';
</style>
